import { IMenuItem } from "dots-ui/dotsMenuBar";
import { avisRoutes } from "./avisRoutes";
import { matchPath } from "react-router-dom";

export const getVerticalBarMenuItems = (
  pathname: string,
): IMenuItem[] | undefined => {
  const route = avisRoutes.find(
    (x) => matchPath({ path: x.path }, pathname) !== null,
  );

  return route?.navItems;
};
